import { useEffect } from "react";
import { Menu, Icon, Button, Checkbox } from "semantic-ui-react";
import {
  StudentMenu,
  MobileMenu,
} from "../../components/Student/StudentLayout";
import { NotificationBell } from "../../components/Shared";
import { useAuth, useNotifications } from "../../hooks";
import { socket } from "../../utils"; // Importa el socket
import { showInfo } from "../../utils/sweetalert";
import "./StudentLayout.scss";

export function StudentLayout(props) {
  const { children } = props;
  const {
    user,
    accessToken,
    studentSidebarOpen,
    setStudentSidebarOpen,
    darkLightTheme,
    setDarkLightTheme,
  } = useAuth();
  const { notifications, unreadCount, reloadNotifications } =
    useNotifications();

  useEffect(() => {
    console.log("Escuchando notificaciones de post", socket);

    console.log("user", user);

    // Autenticar el socket y unirse a la sala del usuario
    const authenticate = () => socket.emit("authenticate", user);
    authenticate();

    // Re-autenticar tras cualquier reconexión (ej. el backend se reinició):
    // el servidor pierde la membresía a la sala `user_{id}` en cada conexión
    // nueva, así que hay que volver a unirse o dejamos de recibir pushes.
    socket.on("connect", authenticate);

    // Escucha el evento de notificación de post
    socket.on("forumNotification", (notification) => {
      console.log("Nueva notificación de post:", notification);
      // Aquí puedes manejar la notificación, por ejemplo, mostrando un mensaje al usuario
      reloadNotifications();
      showInfo(notification.title, notification.message);
    });

    // Limpia el evento cuando el componente se desmonta
    return () => {
      socket.off("connect", authenticate);
      socket.off("forumNotification");
    };
  }, [user, accessToken, reloadNotifications]);

  const backgroundImage = darkLightTheme
    ? "url('/img/fondo_negativo.png')"
    : "url('/img/fondo.png')";

  return (
    <div className="student-layout">
      {/* Sidebar */}
      <section
        className={`student-layout__left ${studentSidebarOpen ? "open" : ""}`}
      >
        <StudentMenu
          sidebarOpen={studentSidebarOpen}
          darkLightTheme={darkLightTheme}
          setDarkLightTheme={setDarkLightTheme}
        />
      </section>
      {/* Main Content */}
      <section
        className={`student-layout__right ${studentSidebarOpen ? "open" : ""}`}
      >
        {/* Top Bar */}
        <Menu className="student-layout__right-header" secondary>
          <MobileMenu darkLightTheme={darkLightTheme} />
          <Button
            icon={studentSidebarOpen ? "close" : "bars"}
            className="student-layout__right-header-button"
            onClick={() => setStudentSidebarOpen(!studentSidebarOpen)}
          />
          <Menu.Menu position="right">
            <Menu.Item className="student-layout__right-header-setings">
              <Icon
                name={darkLightTheme ? "moon" : "sun"}
                color={darkLightTheme ? "grey" : "yellow"}
                style={{ alignSelf: "center", margin: 0 }}
              />
              <Checkbox
                toggle
                checked={darkLightTheme}
                onChange={() => setDarkLightTheme(!darkLightTheme)}
                style={{ alignSelf: "center", margin: 0 }}
              />
              <NotificationBell
                unreadCount={unreadCount}
                notifications={notifications}
                onReloadNotifications={reloadNotifications}
              />
            </Menu.Item>
          </Menu.Menu>
        </Menu>
        {/* Dashboard Content */}
        <div
          className="student-layout__right-content"
          style={{
            backgroundImage: backgroundImage,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            transition: "background-image 0.4s ease-out",
          }}
        >
          {children}
        </div>
      </section>
    </div>
  );
}
